/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const TREND_UP = `up`;
export const TREND_DOWN = `down`;
export const TREND_FLAT = `flat`;
export const DASHBOARD_SUMMARY_TIME_PERIOD = {
  day: 'day',
  days: 'days',
  hour: 'hour',
  hours: 'hours',
} as const;
